import type { App } from 'vue'
import { debounce } from './debounce'
import { track } from './track'

/**
 * 注册全局指令
 * @param app Vue 应用实例
 */
export function setupDirectives(app: App) {
  // 注册防抖指令
  app.directive('debounce', debounce)
  // 注册埋点指令
  app.directive('track', track)
}

// 导出指令，支持按需使用
export { debounce, track }
